<template lang="pug">

    // CONTENEDOR PRINCIPAL
    v-card( :class=" { 'elevation-0': noElevation }" )

        // MENSAJE DE CARGA
        template( v-if='loading' )
            v-progress-linear.ma-0( indeterminate )
            v-container( fluid pa-5 )
                v-layout( row wrap )
                    v-flex( xs12 text-xs-center )
                        span.subheading.font-weight-medium.grey--text.text--darken-2 Un momento por favor, estamos consultando la información necesaria...
        
        // COMPONENTES DEL FORMULARIO
        template( v-else )

            // TITULO, OPCIONES Y EDITABLE SWITCH
            template( v-if='formTitle || editable' )
                v-container( fluid px-4 )
                    v-layout( row wrap align-center )
                        v-flex( xs12 sm6 px-4 )
                            h1.title( v-if='formTitle' ) {{ formTitle }}
                        v-flex( xs12 sm6 pr-5 align-center style='display:flex; flex-direction:row;' )
                            v-spacer
                            slot( name='headersButton' )
                            v-switch.ml-3.my-0.pa-0.d-inline( hide-details label='Editar' style='max-width:100px;' v-model='editSwitch' v-if='editable' )
                v-divider

            //v-card-actions
                .controls-area
                    .switch-container(v-if="editable")
                        span.mr-2.title.pt-1 Editar
                        v-switch.switch(v-model="editSwitch")
            //v-divider.mb-4(v-if="editable")

            // CONTENIDO PREVIO
            template( v-if='$slots.prependContent' )
                v-container( fluid  )
                    v-layout( row wrap )
                        v-flex( xs12 )
                            slot( name="prependContent" )
                v-divider

            // FORMULARIO
            v-form.container.fluid( :class="{ 'pa-5': !noPadding }" ref='form' )
                v-layout( row wrap )
                    
                    // CAMPOS DEL FORMULARIO
                    v-flex.mt-2.pa-0( :class='setVFlexClass( field, idx )' :key='idx' v-for='( field, idx ) in fields' )

                        // CAMPO DE TEXTO O CONTRASEÑA
                        v-text-field.mr-4(
                            v-if="field.type == 'text' || field.type == 'password'" 
                            :type="field.type == 'password' ? 'password' : 'text'" 
                            v-bind="field.vuetifyProps"  
                            v-model="vmodels[field.field]" 
                            :ref="field.field + '-input'"
                            :rules="setRules(field)"
                            :maxlength="''+field.maxLength"
                            :readonly="!formIsFillable || field.readonly"
                            single-line
                            :outline='true'
                            :mask="setMask(field)"
                            @input="sendOnInput({field: field.field, value: vmodels[field.field], vmodels: allModels, fullField: field})"
                            @keyup.enter='submitForm'
                            )
                            span.font-weight-bold.mt-1.mr-2( slot='prepend-inner' style='white-space:pre;' ) {{ field.vuetifyProps.label }}
                            //span.form-label( slot='prepend' v-if='showLabels' ) {{ field.vuetifyProps.label }}
                        
                        // CAMPO DE PRECIO
                        float-input(
                            v-else-if="field.type == 'float'"
                            showLabels 
                            type="text" 
                            :text-field-props="field.vuetifyProps"  
                            v-model="vmodels[field.field]" 
                            :ref="field.field + '-input'"
                            :maxlength="''+field.maxLength"
                            :readonly="!formIsFillable || field.readonly"
                            single-line
                            :outline='true'
                            :rules="setRules(field)"                            
                            @input="sendOnInput({field: field.field, value: vmodels[field.field], vmodels: allModels, fullField: field})"
                            @keyup.enter='submitForm'
                            )
                            span.font-weight-bold.mt-1.mr-2( slot='prepend-inner' style='white-space:pre;' ) {{ field.vuetifyProps.label }}
                        //
                        v-text-field.mr-4(
                            v-else-if="field.type == 'readonly'" 
                            type="text" 
                            v-bind="field.vuetifyProps"  
                            v-model="vmodels[field.field]" 
                            :ref="field.field + '-input'"
                            :rules="setRules(field)"
                            :maxlength="''+field.maxLength"
                            disabled
                            :single-line = 'showLabels'
                            :outline = 'showLabels'
                            :mask="setMask(field)"
                            )
                            .form-label.mt-1( slot='prepend' v-if='showLabels' )
                                span.subheading.font-weight-bold.mt-1.mr-2 {{ field.vuetifyProps.label }}:
                        
                        v-text-field.mx-3(
                            v-else-if="field.type == 'computed'" 
                            type="text" 
                            v-bind="field.vuetifyProps"  
                            v-model="cmodels[field.field]" 
                            :ref="field.field + '-input'"
                            :rules="setRules(field)"
                            :maxlength="''+field.maxLength"
                            disabled
                            :single-line = 'showLabels'
                            :outline = 'showLabels'
                            :mask="setMask(field)"
                            )
                            div.formLabel(slot="prepend" v-if="showLabels")
                                |{{field.vuetifyProps.label}}
                        
                        // AUTOCOMPLETE
                        v-autocomplete.mx-3(
                            v-else-if="field.type == 'autocomplete'" 
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]" 
                            :items="field.options"
                            :maxlength="''+field.maxLength"
                            :readonly="!formIsFillable"
                            :rules="setRules(field)"
                        )
                            span.title( slot='prepend' v-if='showLabels' ) {{ field.vuetifyProps.label }}


                        // DATEPICKER
                        v-menu(
                            v-else-if="field.type === 'datePicker'"
                            :close-on-content-click="false"
                            :return-value="vmodels[field.field]"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            :ref="`dateMenu${field.field}`"
                            v-model="dateMenus[field.field]"
                            @input="sendOnInput({field: field.field, value: vmodels[field.field], vmodels: allModels, fullField: field})"
                            )
                                template(slot="activator")
                                    v-text-field.mr-4(
                                        outline
                                        single-line
                                        v-model="dmodels[field.field]"
                                        v-bind="field.vuetifyProps"
                                        readonly
                                        :rules="setRules(field)"
                                        @blur="vmodels[field.field] = parseDate(dmodels[field.field])"
                                        
                                    )
                                        span.font-weight-bold.mt-1.mr-2( slot='prepend-inner' style='white-space:pre;' ) {{ field.vuetifyProps.label }}
                                v-date-picker(
                                    v-if="!editable || (editable && editSwitch)"
                                    v-bind="field.pickerProps"
                                    v-model="vmodels[field.field]"
                                    :color="colors.primary"
                                    first-day-of-week="1"
                                    locale="es"
                                    :ref="`datePicker${field.field}`"
                                    :readonly="!formIsFillable || field.readonly"
                                    @input="dmodels[field.field] = formatDate(vmodels[field.field])"

                                    )

                        // AUTOCOMPLETE OBJECT
                        v-autocomplete.mr-4(
                            v-else-if="field.type == 'autocompleteObject'" 
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]" 
                            :items="field.options.data"
                            :item-text ='field.options.text'
                            :item-value ='field.options.value'
                            :maxlength="''+field.maxLength"
                            :readonly="!formIsFillable || field.readonly"
                            hide-selected = true
                            @input="autocompleteObjSelectId($event,field.options.text,{field: field.field, value: vmodels[field.field], vmodels: vmodels})"
                            single-line
                            outline
                            :rules="setRules(field)"
                            @keyup="autocompleteObjSelectId($event,field.options.text,{field: field.field, value: vmodels[field.field], vmodels: vmodels})"
                        )
                            span.font-weight-bold.mt-1.mr-2( slot='prepend-inner' style='white-space:pre;' ) {{ field.vuetifyProps.label }}

                        v-select.mr-4(
                            v-else-if="field.type == 'select'" 
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]" 
                            :items="field.options"
                            :readonly="!formIsFillable"
                        )
                            template( slot='prepend-inner' v-if='showLabels' )
                                span.subheading.font-weight-bold.mt-1.mr-2 {{ field.vuetifyProps.label }}
                        v-combobox.mx-3(
                            chips
                            deletable-chips
                            multiple
                            v-else-if="field.type === 'combobox'"
                            v-bind="field.vuetifyProps"
                            v-model="vmodels[field.field]"
                            :items="vmodels[field.field]"
                            :readonly="!formIsFillable"
                            :outline="showLabels"
                            @change="sendOnInput({field: field.field, value: vmodels[field.field], vmodels: vmodels, fullField: field})"
                            :rules="setRules(field)"
                        )
                            div.formLabel(slot="prepend" v-if="showLabels")
                                |{{field.vuetifyProps.label}}
                        
                        // CAMPO RUT
                        rut-input.mr-4(
                            v-else-if="field.type === 'rut'" 
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]"
                            :readonly="!formIsFillable"
                            :show-labels='showLabels'
                        )
                            span.font-weight-bold.mt-1.mr-2( slot='prepend-inner' style='white-space:pre;' ) {{ field.vuetifyProps.label }}
                            //.form-label.mt-1( slot='prepend' v-if='showLabels' )
                                span.subheading.font-weight-bold.mr-2 {{ field.vuetifyProps.label }}:
                        v-textarea.mr-4(
                            v-else-if="field.type == 'textarea'" 
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]"
                            :maxlength="''+field.maxLength"
                            :readonly="!formIsFillable"
                            :rules="setRules(field)"
                            :outline="showLabels"
                        )
                            div.formLabel(slot="prepend" v-if="showLabels" )
                                span.subheading.font-weight-bold.mt-1.mr-2 {{field.vuetifyProps.label}}:
                        v-textarea.mx-3(
                            v-else-if="field.type == 'textarea-readonly'" 
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]"
                            :maxlength="''+field.maxLength"
                            :readonly="!formIsFillable"
                            :rules="setRules(field)"
                            disabled
                        )
                            div.formLabel(slot="prepend" v-if="showLabels" )
                                |{{field.vuetifyProps.label}}
                        v-layout.checkTitle( v-else-if="field.type == 'checkbox'" row)
                            v-checkbox.mx-3(
                                v-bind="field.vuetifyProps" 
                                v-model="vmodels[field.field]"
                                :readonly="!formIsFillable"
                                @change="sendOnInput({field: field.field, value: vmodels[field.field], vmodels: vmodels, fullField: field})"
                                )                    
                        .section.my-4(v-else-if="field.type === 'section'")
                            h2.title {{field.field}}
                            v-divider.mx-3

                        .section.mb-4( v-else-if=' field.type === "divider" ' )
                            h2.subheading.font-weight-bold {{ field.title }}
                            v-divider.mx-3

                        // AUTOCOMPLETE MODEL
                        model-auto-complete.mr-4(
                            v-bind='field.vuetifyProps' 
                            v-else-if='field.type === "model-auto-complete"'
                            v-model='vmodels[ field.field ]'
                            )
                            span.font-weight-bold.mr-2( slot='prepend-inner' style='white-space:pre;line-height:1.25;' ) {{ field.vuetifyProps.label }}

                        // SLOT
                        slot( :name=' "slot-" + field.field ' )

                        
                    // CONTENIDO POSTERIOR
                    template( v-if='$slots.appendContent' )
                        v-flex( xs12 pa-0 )
                            slot( name="appendContent" )

            // BOTONES DE ACCIONES
            template( v-if='!noButtons' )
                v-divider
                v-container( fluid py-2 grey lighten-3 :class='{ "px-4": !noPadding, "px-3": noPadding }' )
                    v-layout( row wrap )
                        v-flex( xs12 style='display:flex; flex-direction:row;' )
                            slot( name='prependButton' )
                            v-btn.ma-2.secondary--text( block :disabled='!formIsFillable' v-if='!noReset' @click='resetForm' ) {{ editable ? 'restaurar valores' : 'limpiar' }}
                            slot( name='insertButton' )
                            v-btn.ma-2( block color='primary' :disabled='!formIsSubmittable' @click='submitForm' ) {{ submitText }}
                            slot( name='appendButton' )
</template>

<script>
import InputValidations from '@/mixins/reusable_mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/reusable_mixins/CurrencyUtils'
import RUTInput from '../RUTInput/RUTInput'
import InputFormatters from './InputFormatters.js'
import FloatInput from '../Input/FloatInput'
//
import { ModelAutocomplete } from '../next'
//
export default {
    name: 'crud-form',
    props: {
        noButtons: {
            type: Boolean,
            default: () => false,
        },
        fields: {
            type: Array,
            default: () => [],
        },
        toolbarTitle: {
            type: String,
            default: () => 'title',
        },
        toolbarIcon: {
            type: String,
            default: () => 'info',
        },
        customRules: {
            type: Object,
            default: () => {},
        },
        editable: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        submitText: {
            type: String,
            default: 'Enviar',
        },
        showLabels: {
            type: Boolean,
            default: true,
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
        formTitle: {
            type: String,
            default: null,
        },
        focus: {
            type: String,
            default: null,
        },

        /**
         *
         */
        formPadding: {
            type: Number,
            default: 5,
        },

        /**
         *
         */
        loading: {
            type: Boolean,
            default: false,
        },

        /**
         *
         */
        noElevation: Boolean,

        /**
         *
         */
        noReset: Boolean,
    },
    data: function() {
        return {
            vmodels: {},
            cmodels: {},
            dmodels: {},
            dateMenus: {},
            editSwitch: false,
        }
    },
    computed: {
        formIsValid: function() {
            return this.$refs.form.validate()
        },
        formIsFillable: function() {
            if (!this.editable && !this.readOnly && !this.disabled) return true
            if (this.editable && this.editSwitch) return true
            return false
        },
        formIsSubmittable: function() {
            if (!this.editable && !this.readOnly && !this.disabled) return true
            if (this.editable && this.editSwitch) return true
            return false
        },
        allModels: function() {
            return { ...this.vmodels, ...this.cmodels }
        },
    },
    methods: {
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}-${month}-${year}`
          },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('-')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        /**
         *
         */
        resetForm() {
            //
            if (this.editable) this.setVmodels()
            //
            this.vmodels = {}
            this.cmodels = {}
            this.setVmodels()
            this.$emit('reset')
            this.$refs.form.reset()
        },
        /**
         *
         */
        toggleReadOnlyForm: function(bool) {
            this.fields.forEach(field => {
                let fieldProps
                if (field.type == 'rut') {
                    fieldProps = field.vuetifyProps
                    fieldProps.textFieldProps.readonly = bool
                    field.vuetifyProps = { ...fieldProps }
                    return
                }
                if (
                    field.type == 'select' ||
                    field.type == 'checkbox' ||
                    field.type == 'autocomplete'
                ) {
                    fieldProps = field.vuetifyProps
                    fieldProps.disabled = bool
                    field.vuetifyProps = { ...fieldProps }
                    return
                }
                fieldProps = field.vuetifyProps
                fieldProps.readOnly = bool
                field.vuetifyProps = { ...fieldProps }
            })
        },
        disabledForm: function() {},
        submitForm: function() {
            if (this.formIsValid) {
                this.$emit('submitForm', { ...this.vmodels, ...this.cmodels })
            }
        },
        setRules: function(field) {
            if (!field.rules) return []
            let rules = field.rules.map(ruleName => {
                return this.mixRules[ruleName]
            })
            if (!field.customRules) return rules
            let customRules = field.customRules.map(ruleName => {
                return this.customRules[ruleName].bind(this)
            })
            rules = rules.concat(customRules)
            return rules
        },
        setVFlexClass: function(field, idx) {
            if (field.flex !== undefined) return field.flex
            if (field.type === 'divider') return { md12: true, xs12: true }
            if (field.type === 'section') return { md12: true, xs12: true }
            if (field.type !== 'textarea') return { md6: true, xs12: true }
            if (field.type === 'textarea') return { md12: true, xs12: true }
            if (field.type === 'checkbox')
                return { md12: true, xs12: true, 'text-sm-center': true }
        },
        setVmodels: function() {
            let vmodels = {}
            let dateMenus = {}
            let computed = this.fields.filter(
                field => field.type === 'computed' && field.computed
            )
            this.fields.forEach(field => {
                if (field.type !== 'computed' && field.type !== 'section')
                    vmodels[field.field] = field.value
                if (field.type === 'datePicker') {
                    this.dmodels[field.field] = field.value
                    dateMenus[field.field] = false
                }
            })
            computed.forEach(field => {
                this.cmodels[field.field] = field.computed(vmodels)
            })
            this.vmodels = { ...vmodels }
            this.dateMenus = { ...dateMenus }
        },
        autocompleteObjSelectId: function(event, selectType, field) {
            let payload = {
                id: event,
                type: selectType,
            }
            this.sendOnInput(field)
            //
            //console.log( event )
            //
            this.$emit('autocompleteObjSelectId', payload)
            this.$emit(
                'autocompleteObjectValue',
                event.target && event.target.value
            )
        },
        textWrite: function(event, type) {
            let payload = {
                value: event,
                label: type,
                // value : value,
            }
            this.$emit('textWrite', payload)
        },
        setMask(field) {
            if (field.vuetifyProps.mask) return field.vuetifyProps.mask
            if (field.format && field.format === 'currency')
                return this.mixCurrencyMask(
                    this.vmodels[field.field],
                    field.maxLength || 10
                )
            if (field.format === 'number') {
                let mask = ''
                for (let idx = 0; idx < (field.maxLength || 10); idx++) {
                    mask += '#'
                }
                return mask
            }
            return ''
        },

        sendOnInput(field) {
            if (
                field &&
                field.fullField &&
                field.fullField.format &&
                field.fullField.format === 'float'
            ) {
                if (!this.mixFloatInput(field.value)) {
                    this.$nextTick(() => {
                        this.vmodels[field.field] = this.mixCheckFloat(
                            field.value
                        )
                    })
                }
            }
            this.$emit('calculate', field)
        },

        /**
         *
         */
        setValue(name, value) {
            this.vmodels = { ...this.vmodels, [name]: value }
        },
    },
    watch: {
        editSwitch() {
            this.$emit('editable', { editable: this.editSwitch })
        },
        formIsFillable: function(newVal, oldVal) {
            this.toggleReadOnlyForm(newVal ? false : true)
        },
        fields: function(newVal) {
            this.setVmodels()
            deep: true
        },
        vmodels: {
            deep: true,
            handler: function() {
                this.fields
                    .filter(
                        field => field.type === 'computed' && field.computed
                    )
                    .forEach(field => {
                        this.cmodels[field.field] = field.computed(this.vmodels)
                    })
            },
        },
        focus: function(val) {
            if (val) {
                if (this.$refs[val + '-input']) {
                    this.$nextTick(() => {
                        this.$refs[val + '-input'][0].focus()
                    })
                }
            }
        },
    },
    components: {
        'model-auto-complete': ModelAutocomplete,
        'rut-input': RUTInput,
        'float-input': FloatInput,
    },
    mixins: [InputValidations, CurrencyUtils, InputFormatters],
    filters: {},
    created: function() {
        this.setVmodels()
    },
    mounted: function() {
        if (this.focus) {
            if (this.$refs[this.focus + '-input']) {
                this.$nextTick(() => {
                    this.$refs[this.focus + '-input'][0].focus()
                })
            }
        }
    },
    // beforeUpdate: function(){
    //     this.setVmodels()
    // }
}
</script>

<style lang="scss">
.controls-area {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    .switch-container {
        display: flex;
        flex-direction: row;
        // padding-top: 2.5%;
        span {
            margin-top: 1px;
        }
    }
    .switch {
        margin-top: -2px;
        margin-left: 10px;
    }
}
.formLabel {
    font-weight: bold;
    min-width: 150px;
    max-width: 150px;
    font-size: 20px;
}
.section {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.form-label {
    min-width: 150px;
}
.mt-1--5 {
    margin-top: 3px;
}
</style>
